<template>

  <DoubleColumnLayout>

    <v-container>

        <!-- Kalkules WP Top Banner -->
        <ConditionalAdsense
          data-ad-client="ca-pub-1338414232761221"
          data-ad-slot="3661147294"
          data-ad-format="auto"
          data-full-width-responsive="true"
        >
        </ConditionalAdsense>

      <h1>{{ $t('online.numberTextQuizEs.title') }}</h1>
      <text-quiz
        :question-label="$t('online.numberTextQuizEs.questionLabel')"
        :answer-label="$t('online.numberTextQuizEs.answerLabel')"
      />

    </v-container>

    <template v-slot:right>
      <AppList />
    </template>

  </DoubleColumnLayout>

</template>

<script>

import AppList from "@/components/AppList.vue";
import ConditionalAdsense from "@/components/ConditionalAdsense.vue";
import DoubleColumnLayout from "@/components/DoubleColumnLayout.vue";
import TextQuiz from "@/components/TextQuiz.vue";

export default {
  name: "NumberTextQuizEsView",
  components: {
    AppList,
    ConditionalAdsense,
    DoubleColumnLayout,
    TextQuiz,
  },
  metaInfo() {
    return {
      title: this.$t('online.numberTextQuizEs.metaTitle'),
      meta: [
        { property: "og:title", content: this.$t('online.numberTextQuizEs.metaTitle') },
        { property: "og:description", content: this.$t('online.numberTextQuizEs.metaDescription') },
        { name: "twitter:title", content: this.$t('online.numberTextQuizEs.metaTitle') },
        { name: "twitter:description", content: this.$t('online.numberTextQuizEs.metaDescription') },
        { itemprop: "name", content: this.$t('online.numberTextQuizEs.metaTitle') },
        { itemprop: "description", content: this.$t('online.numberTextQuizEs.metaDescription') },
      ],
    };
  },
};

</script>